'use strict';

module.exports = require('./components/DocEditor/editLineItems').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/editLineItems.js
// module id = 1832
// module chunks = 0